import Header from "@Components/Header.jsx";

// Import Swiper styles
import Footer from "@/Components/Footer.jsx";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Head } from '@inertiajs/react'

import ChatBot from "@/Components/ChatBot/ChatBot";
import DecorBlob from "@/Components/Decor/DecorBlob.jsx";
import DecorContainer from "@/Components/Decor/DecorContainer.jsx";

function Page(pageProps) {
    return (
        <>
            <Head>
                <title>{'Vivanti - ' + pageProps.page.name}</title>
                <meta name="description" content={pageProps.page.description} />
            </Head>

            <Header locale={pageProps.locale} menu={pageProps.menu}></Header>

            <section
                className={"container mt-80px mb-80px ph:mb-100px pb-100px"}
            >
                <div className={"container__inner"}>
                    <div className={"team__desc"}>
                        <h1
                            className={"mb-48px ph:mb-60px"}
                            dangerouslySetInnerHTML={{
                                __html: pageProps.page.name,
                            }}
                        ></h1>
                        <div
                            className={"team__desc-list"}
                            dangerouslySetInnerHTML={{
                                __html: pageProps.page.body,
                            }}
                        ></div>
                    </div>
                </div>

                <DecorContainer>
                    <DecorBlob
                        typeNum={3}
                        width={1520}
                        blur={100}
                        rotate={50.46}
                        opacity={0.7}
                        x={150}
                        y={-130}
                    />
                    <DecorBlob
                        typeNum={3}
                        width={10000}
                        blur={300}
                        rotate={45}
                        opacity={0.7}
                        x={900}
                        y={-500}
                    />
                    <DecorBlob
                        typeNum={3}
                        width={10000}
                        blur={300}
                        rotate={90}
                        opacity={0.7}
                        x={-9000}
                        y={5000}
                    />
                    <DecorBlob
                        typeNum={3}
                        width={2000}
                        blur={300}
                        rotate={45}
                        opacity={0.7}
                        x={1200}
                        y={11000}
                    />
                </DecorContainer>
            </section>

            <ChatBot
                csrf_token={pageProps.csrf_token}
                user_id={pageProps.user_id}
                is_admin={pageProps.is_admin}
            ></ChatBot>

            <Footer pageProps={pageProps}></Footer>
        </>
    );
}


export default Page;
